module.exports = __webpack_public_path__ + "img/number-of-packages.bec97a45.svg";